import { BookFill, PeopleFill, BrowserChrome} from 'react-bootstrap-icons'


const dashboard = [
   {
      title: 'Книги',
      link: '',
      icon: (<BookFill/>)
   },
   {
      title: 'Админ аккаунт',
      link: '',
      icon: (<PeopleFill/>)
   },
   {
      title: 'Бiблiотека',
      link: '/',
      icon: (<BrowserChrome/>)
   }
]

export default dashboard;